import React from 'react';
import { StandardBanner as _StandardBanner } from '@uk-source-web/standard-banner';
import { SWSectionStandardBannerProps } from './SWSectionStandardBanner.types';
import { getImage, getSrc } from 'gatsby-plugin-image';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { renderToString } from 'react-dom/server';
import usingOpcoUrl from '@/helpers/prefixHelper';
import { StandardBannerWrapper } from './SWSectionStandardBanner.styles';

const SWSectionStandardBanner = ({
  backgroundColor,
  backgroundImage,
  heading,
  headingLevel,
  footNote,
  contentAlignment,
  contentSize,
  bigHeading,
  textColor,
  bodyText,
  primaryButton,
  secondaryButton,
  shortenHeight,
}: SWSectionStandardBannerProps) => {
  const backgroundImageSrc = getSrc(backgroundImage) || '' || getImage(backgroundImage)?.placeholder?.fallback || '';
  const richTextBodyJson = bodyText && JSON.parse(bodyText.raw);
  const richTextBodyContent = richTextBodyJson && { ...richTextBodyJson, content: richTextBodyJson.content[0].content };
  const imageTitleSrc = getSrc(backgroundImage?.imageTitle);
  const imageTitlePlaceholder = getImage(backgroundImage?.imageTitle)?.placeholder?.fallback;
  const mobileBackgroundImageSrc = getSrc(backgroundImage?.mobileBackgroundImage);
  const mobileBackgroundImagePlaceholder = getImage(backgroundImage?.mobileBackgroundImage)?.placeholder?.fallback;
  return (
    <StandardBannerWrapper
      textColor={textColor}
      backgroundColor={backgroundColor}
      bigHeading={bigHeading}
      shortenHeight={shortenHeight}
    >
      <_StandardBanner
        id={'standard-banner-id'}
        backgroundColor={backgroundColor ? backgroundColor : '#fff'}
        backgroundImage={{
          sm: {
            src: mobileBackgroundImageSrc || mobileBackgroundImagePlaceholder || '',
          },
          md: {
            src: imageTitleSrc || imageTitlePlaceholder || '',
          },
          lg: {
            src: imageTitleSrc || imageTitlePlaceholder || '',
          },
          xl: {
            src: imageTitleSrc || imageTitlePlaceholder || '',
          },
        }}
        paragraph={
          bodyText
            ? {
                text: bodyText && renderToString(documentToReactComponents(richTextBodyContent)),
              }
            : undefined
        }
        contentAlignment={contentAlignment ? contentAlignment : 'left'}
        contentSize={contentSize ? contentSize : 1}
        footnote={
          footNote
            ? {
                text: footNote.text,
                link: {
                  text: footNote.urlText,
                  href: footNote.url,
                },
              }
            : undefined
        }
        heading={{
          text: heading ?? '',
          level: headingLevel ? headingLevel : 2,
        }}
        primaryButton={
          primaryButton
            ? {
                text: primaryButton?.label,
                href: usingOpcoUrl(primaryButton?.url),
                ...(primaryButton.customAttributesJson && {
                  htmlAttributes: { ...primaryButton.customAttributesJson },
                }),
              }
            : undefined
        }
        secondaryButton={
          secondaryButton
            ? {
                text: secondaryButton?.label,
                href: usingOpcoUrl(secondaryButton?.url),
                ...(secondaryButton.customAttributesJson && {
                  htmlAttributes: { ...secondaryButton.customAttributesJson },
                }),
              }
            : undefined
        }
      />
    </StandardBannerWrapper>
  );
};

export default SWSectionStandardBanner;
